import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import { myAxios } from "src/components/common/functions";
import { useMyStore } from "src/components/main/mainStore";
import Form from "../form";
//--------------------------------------------------------------------------------------------
export const items = [
    {title: "safetyInspectionBlock1", type: "display", content: <h4>Preliminary</h4>},
    {title: "Project Name", type: "Select", options: []}, 
    {title: "Jobsite Location", type: "text"}, 
    {title: "Traffic Control Plan review and printout", type: "text"},
    {title: "Employees scheduled to be on site:", type: "text"},
    {title: "Employees Info", type: "object", default: "[]", schema: [
        {title: "name", type: "Select", options: []},
        {title: "ISN", type: "radio"},
        {title: "ISN Card on hand", type: "radio"},
        {title: "ITS Verified (Operator only)", type: "Select", options: ["Yes", "No", "NA"].map(u => ({label: u, value: u}))},
        {title: "Veriforce", type: "Select", options: ["Yes", "No", "NA"].map(u => ({label: u, value: u}))},
        {title: "NCCER", type: "Select", options: ["Yes", "No", "NA"].map(u => ({label: u, value: u}))},
    ]}, 
    {title: "ISN check for each employee", type: "textarea"},
    {title: "Operator Qualifications", type: "textarea"},
    {title: "safetyInspectionBlock2", type: "display", content: <hr className = "w-100"/>},
    {title: "safetyInspectionBlock3", type: "display", content: <h4>Inspection</h4>},
    {title: "Copy of permits on site", type: "radio"},
    {title: "USA Tickets viewable", type: "radio"},
    {title: "Surface Restoration Requirements", type: "select", options: ["per permit", "county standard"].map(u => ({label: u, value: u}))},
    {title: "Backfill", type: "select", options: ["slurry", "cement", "AB", "native"].map(u => ({label: u, value: u}))},
    {title: "Equipment on-hand: Vibe Plate", type: "radio"},
    {title: "Equipment on-hand: Hot Patch", type: "radio"},
    {title: "Equipment on-hand: Cold Patch", type: "radio"},
    {title: "Traffic Control Setup complete? (This entails the correct signs and cone layout) ", type: "radio"},
    {title: "Vehicles Info", type: "object", default: "[]", schema: [
        {title: "truck number", type: "Select", options: []},
        {title: "parked", type: "radio"},
        {title: "chocked", type: "radio"},
        {title: "if on hill, wheel direction toward curb", type: "radio"},
        {title: "safety lights on", type: "radio"},
        {title: "360", type: "radio"},
        {title: "support vehicle has 2 cones 1 on front and back", type: "radio"},
        {title: "security", type: "radio"},
        {title: "running", type: "radio"},
        {title: "cleanliness", type: "radio"},
        {title: "tire wear", type: "radio"},
    ]},
    {title: "JSA Completion? Reviewed for risk assessment which should be site/environment dependent, if after lunch, was it updated for scope of work change/site visitors?", type: "textarea"},
    {title: "safetyInspectionBlock4", type: "display", content: <hr className = "w-100"/>},
    {title: "safetyInspectionBlock5", type: "display", content: <h4>Employees</h4>},
    {title: "PPE for jobsite:Hard hats? Gloves? Safety glasses? Face shield (if operating with hydro or air)? Ear Protection (plugs) (Toe Covers f/jackhammer)? Appropriate footwear (Ankle covered boots)  Water Availability (Temp depending 72 degrees and up) Trained on the task (Ask employees)  Y/N___ (Keep in mind most of our training is OJT)", type: "textarea"},
    {title: "safetyInspectionBlock6", type: "display", content: <hr className = "w-100"/>},
    {title: "safetyInspectionBlock7", type: "display", content: <h4>Workflow</h4>},
    {title: "safetyInspectionBlock8", type: "display", content: <h5>To measure progress or productivity it will need to be kept to clear standards.</h5>},
    {title: "Did team start on time?", type: "radio"},
    {title: "Did team conduct JSA on time?", type: "radio"},
    {title: "JSA included hazards?", type: "radio"},
    {title: "Did team meet their daily goal/quota?", type: "Select", options: ["Yes", "No", "NA"].map(u => ({label: u, value: u}))},
    {title: "Was team on site for required time (If departure time was scheduled i.e. 9-3 work hours)", type: "radio"},
    {title: "Right Tools (employees prepared appropriately, brought necessary equipment from yard, dispatch included everything needed, whip checks installed, tools safe for operation)", type: "radio"},
    {title: "Equipment Summary", type: "textarea"},
    {title: "safetyInspectionBlock9", type: "display", content: <hr className = "w-100"/>},
    {title: "Approver Notes"}
];
export default function CalibrationVerification({
    closeIt, 
    form, 
    picData, setPicData, 
    sketches, setSketches, 
    usersList, setUserList
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [projects, setProjects] = useState([]);
    const [truckNumbers, setTruckNumber] = useState([]);
    items[1].options = projects.map(project => ({
        value: project.projectName, 
        label: project.projectName
    }));
    items[5].schema[0].options = usersList.map(u => ({label: u.userName, value: u.userName}));
    items[18].schema[0].options = truckNumbers.map(u => ({label: u, value: u}));
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            setShowLoader(true);
            const resProjectNames = await myAxios("common/readProjectNames.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resProjectNames) return;
            setProjects(resProjectNames.data);

            setShowLoader(true);
            const resTruckNumbers = await myAxios("common/readTruckNumbers.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!resTruckNumbers) return;
            setTruckNumber(resTruckNumbers.data.map(truck => truck.truckNumber));
        }
        getData();
        return () => {
            isMounted = false;
        }
    },[]);
    //--------------------------------------------------------------------------------------------

    //--------------------------------------------------------------------------------------------
    return(
        <Form
            closeIt = {closeIt}
            form = {form}
            picData = {picData}
            setPicData = {setPicData}
            sketches = {sketches}
            setSketches = {setSketches}
            usersList = {usersList}
            setUserList = {setUserList}

            items = {items}
        />
    )    
}